export enum SubscriptionBillingState {
  None = "None",
  Active = "Active",
  ActiveWithPastDuePayment = "ActiveWithPastDuePayment",
  Lapsed = "Lapsed",
}
